import React from 'react';

import { useEligibilityBadgeState } from '../hooks/useEligibilityBadgeState';

import { EligibilityStatusBadge } from './EligibilityStatusBadge';
import { EligibilityWarningIcon } from './EligibilityWarningIcon';

export interface EligibilityBadgeProps {
  patientId?: string;
  encounterId?: string;
  source: 'patient_overview' | 'note_metadata';
  onAddInsurance?: () => void;
}

/**
 * Orchestrator component that decides which eligibility badge to render:
 * - No coverages & no eligibility data → existing EligibilityWarningIcon (marketing CTA)
 * - Has coverages or eligibility data → EligibilityStatusBadge (status-aware)
 */
export const EligibilityBadge: React.FC<EligibilityBadgeProps> = ({
  patientId,
  encounterId,
  source,
  onAddInsurance,
}) => {
  const {
    mode,
    eligibilityData,
    status,
    organized,
    canRunCheck,
    runCheck,
    isRunning,
  } = useEligibilityBadgeState({ patientId, encounterId });

  if (mode === 'hidden') return null;

  if (mode === 'no_coverage') {
    return (
      <EligibilityWarningIcon
        patientId={patientId}
        source={source}
        onAddInsurance={onAddInsurance}
      />
    );
  }

  return (
    <EligibilityStatusBadge
      patientId={patientId}
      encounterId={encounterId}
      source={source}
      eligibilityData={eligibilityData}
      status={status}
      organized={organized}
      canRunCheck={canRunCheck}
      runCheck={runCheck}
      isRunning={isRunning}
      mode={mode}
    />
  );
};
